import { createContext, useContext, useRef } from "react";

import { AppContext } from "@vahak/core/dist/app-context";
import { initLorryList, RemoteVehicleInfo } from "@vahak/core/dist/constants";
import { useCsDashboard } from "@vahak/core/dist/hooks/useCsDashboard";

import { useRemoteConfig } from "./context/RemoteConfigContext";
import {
    filterExpirementLorryList,
    NEW_USER_VEHICLE_RESTRICTION_KEY,
    NewUserRestrictionMeta,
    VEHICLE_REMOTE_CONFIG_KEY
} from "./components/posting/load-posting/helpers/lcv-expirement";

const Context = createContext({});

function CommonInnerContextWrapper({ children }: any) {
    const context = useContext(AppContext);
    const { isCsDashboardUser } = useCsDashboard();
    const companyId = Number(context?.customerCompanyId || context?.companyId) || 0;
    const remoteConfig = useRemoteConfig();
    const readRemoteConfig = remoteConfig.readValue;
    const initializedKeyRef = useRef<string | null>(null);

    // Init during render (not useEffect) so children see the list on the same pass as isLoaded.
    if (remoteConfig?.isLoaded) {
        const initKey = `${companyId}-${context?.joinedOn ?? ""}-${isCsDashboardUser}`;

        if (initializedKeyRef.current !== initKey) {
            const loadConfig = readRemoteConfig(VEHICLE_REMOTE_CONFIG_KEY.load, "json", []) as {
                vehicles?: RemoteVehicleInfo[];
            };
            const lorryConfig = readRemoteConfig(VEHICLE_REMOTE_CONFIG_KEY.lorry, "json", []) as {
                vehicles?: RemoteVehicleInfo[];
            };

            let listForLoad = loadConfig?.vehicles ?? [];
            let listForLorry = lorryConfig?.vehicles ?? [];

            if (!isCsDashboardUser) {
                const restrictionMeta = readRemoteConfig(
                    NEW_USER_VEHICLE_RESTRICTION_KEY,
                    "json"
                ) as NewUserRestrictionMeta;
                const joinedOn = context?.joinedOn ?? "";
                listForLoad =
                    filterExpirementLorryList({
                        companyId,
                        joinedOn,
                        list: listForLoad,
                        meta: restrictionMeta,
                        scope: "load"
                    }) ?? [];
                listForLorry =
                    filterExpirementLorryList({
                        companyId,
                        joinedOn,
                        list: listForLorry,
                        meta: restrictionMeta,
                        scope: "lorry"
                    }) ?? [];
            }

            initLorryList(listForLoad, listForLorry);
            initializedKeyRef.current = initKey;
        }
    }

    return <Context.Provider value={{}}>{children}</Context.Provider>;
}

export default CommonInnerContextWrapper;
